import { render } from "./LibraryMaster.vue?vue&type=template&id=653f6dc3&scoped=true"
import script from "./LibraryMaster.vue?vue&type=script&lang=js"
export * from "./LibraryMaster.vue?vue&type=script&lang=js"

import "./LibraryMaster.vue?vue&type=style&index=0&id=653f6dc3&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653f6dc3"]])

export default __exports__